import { prop, required } from '@rxweb/reactive-form-validators';

export class CopyReelModel {
    @required()
    name: string;

    @prop({name: 'groups_id'})
    @required()
    groups_id: string;

}
